import { useLazyGetPresignedUrlsQuery, usePostOnPresignedMutation } from "features/shared/api"
import { useBatchedUploadFromIndexedDB } from "./useBatchedUploadFromIndexedDB"
import { useIndexedDB } from "./useIndexedDB"
import { uploadAndStoreBlobs } from "./useRecording"

const useSyncBlobs = ({ finalUploadQuery, defaultDeleteOnFail, indexDbConfig, batchUploadConfig }) => {
  const { getAllDataFromStore } = useIndexedDB("audioDB", "audio", null, true, [{ storeName: "processedAudio" }])
  const { batchUploadAll } = useBatchedUploadFromIndexedDB("audioDB", "processedAudio", 10, "audioMetadata")
  const [getPresignedUrls] = useLazyGetPresignedUrlsQuery()
  const [postOnPresigned] = usePostOnPresignedMutation()

  const syncData = async (deleteOnFail = defaultDeleteOnFail) => {
    const totalBlobs = (await getAllDataFromStore(null, "processedAudio")) ?? []
    const uploadIdData = await getAllDataFromStore(null, "audioMetadata")
    let meetingId = uploadIdData?.[0]?.meetingId
    let uploadId = uploadIdData?.[0]?.uploadId

    let response = await batchUploadData({
      totalBlobs,
      uploadId,
      meetingId,
      batchUploadAll,
      deleteOnFail,
      finalUploadQuery,
      getPresignedUrls,
      postOnPresigned,
    })
  }

  return { syncData }
}

export default useSyncBlobs

const batchUploadData = async ({
  totalBlobs,
  uploadId,
  meetingId,
  getPresignedUrls,
  postOnPresigned,
  batchUploadAll,
  deleteOnFail,
  finalUploadQuery,
}) => {
  let blobIdString = totalBlobs?.map(item => item?.id)?.toString()
  const batchUploadQuery = blobIdString?.length
    ? await uploadAndStoreBlobs({
        uploadId,
        getPresignedUrls,
        postOnPresigned,
        totalParts: blobIdString,
        id: meetingId,
      })
    : null

  let resp = await batchUploadAll({
    batchQuery: batchUploadQuery,
    finalUploadQuery: finalUploadQuery,
    id: meetingId,
    deleteOnFail: deleteOnFail,
  })
  return resp
}
